import { render, staticRenderFns } from "./EmployerMatchCatchUpRadio.vue?vue&type=template&id=2174ce04&"
import script from "./EmployerMatchCatchUpRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchCatchUpRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports